// src/components/typography/Subtitle.tsx
import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type SubtitleProps = {
  as?: "p" | "span" | "div" | "h2" | "h3" | "h4";
  children: string | ReactNode;
  className?: string;
};

const Subtitle = ({ as = "p", children, className = "" }: SubtitleProps) => {
  const Component = as;

  return (
    <Component
      className={twMerge(
        "justify-start text-center font-serif text-sm font-medium uppercase leading-5 tracking-[4.20px] text-app-300",
        className
      )}
    >
      {children}
    </Component>
  );
};

export default Subtitle;
